/* eslint-ignore import/default */
export const HOME = '/';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const ABOUTUS = '/aboutus';
export const CONFIRMEMAIL = '/confirmEmail/:userId/:token';
export const TIMETABLE = '/timetable';
export const RESETPASSWORD = '/reset-password';
export const SETNEWPASSWORD = '/set-new-password';
export const PERSONALNUMBER = '/personal-number';
export const PRIVACYPOLICY = '/privacypolicy';
//export const WEBVIEWER = '/privacypolicy/web/';



// WEBPACK FOOTER //
// ./src/util/routes.js